import {FC} from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { IGeneralInfoState } from '../../../../common/state/subscriptions/general_info';
// custom
import { IPaymentInfo } from '../../../../common/state/subscriptions/payment_info';

export type BillingInfoFormData = IPaymentInfo;

type IBillingInfoFormProps = {
    defaultFormData: IPaymentInfo,
    onSubmit: (data: IPaymentInfo) => void,
    onBack: () => void
};

const BillingInfoForm: FC<IBillingInfoFormProps> = ({defaultFormData, onSubmit, onBack}) => {
    const { register, handleSubmit } = useForm<BillingInfoFormData>({defaultValues: defaultFormData});
    // states
    const generalInfoState = useSelector(({general_info} : {
        general_info: IGeneralInfoState
    }) => general_info.selected);
    //evt handlers
    const onFormSubmit = (formData: BillingInfoFormData) => {        
        onSubmit(formData);
    };

    return <section id="form-section"
        className="w-full p-4 my-3 mr-3 bg-white shadow-lg lg:w-3/4 rounded-xl dark:bg-gray-900">
        <h1 className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase dark:text-teal-400">
            3. Checkout and Register!
        </h1>
        <p className="p-4 my-4 text-gray-700 dark:text-gray-300 dartext-base">
            Please fill out the billing information in order to complete registration. checkout powered by <strong>Stripe</strong>
        </p>
        <form onSubmit={handleSubmit(onFormSubmit)} className="grid w-full grid-cols-1 gap-4 mb-6 lg:grid-cols-2">
            {/* col 1:1 */}
            <div className="w-full px-3">
                <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase dark:text-teal-400"
                    htmlFor="grid-first-name">
                    First Name*
                </label>
                <input {...register('first_name')}
                    required
                    className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border-2 border-blue-200 rounded appearance-none dark:border-teal-700 focus:outline-none focus:bg-white"
                    id="grid-first-name" type="text" placeholder="John" />
            </div>
            {/* col 1:2 */}
            <div className="w-full px-3">
                <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase dark:text-teal-400"
                    htmlFor="grid-last-name">
                    Last Name*
                </label>
                <input {...register('last_name')}
                    required
                    className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border-2 border-blue-200 rounded appearance-none dark:border-teal-700 focus:outline-none focus:bg-white"
                    id="grid-last-name" type="text" placeholder="Doe" />
            </div>            
            {/* col 2:1 */}
            <div className="w-full px-3">
                <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase dark:text-teal-400"
                    htmlFor="grid-email">
                    Email Address*
                </label>
                <input {...register('email')}
                    required
                    className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border-2 border-blue-200 rounded appearance-none dark:border-teal-700 focus:outline-none focus:bg-white"
                    id="grid-email" type="text" placeholder="john.doe@gmail.com" />
            </div>
            {/* col 2:2 */}
            <div className="w-full px-3">
                <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase dark:text-teal-400"
                    htmlFor="grid-contact">
                    Contact Number*
                </label>
                <input {...register('contact')}
                    required
                    className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border-2 border-blue-200 rounded appearance-none dark:border-teal-700 focus:outline-none focus:bg-white"
                    id="grid-contact" type="text" placeholder="+1 123 45678" />
            </div>
            {/* col 3:1 */}
            <div className="w-full px-3">
                <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase dark:text-teal-400"
                    htmlFor="grid-address">
                    Address*
                </label>
                <input {...register('address')}
                    required
                    className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border-2 border-blue-200 rounded appearance-none dark:border-teal-700 focus:outline-none focus:bg-white"
                    id="grid-address" type="text" placeholder="River Drive, Jersey City" />
            </div>
            {/* col 3:2 */}
            <div className="w-full px-3">
                <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase dark:text-teal-400"
                    htmlFor="grid-city">
                    City*
                </label>
                <input {...register('city')}
                    required
                    className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border-2 border-blue-200 rounded appearance-none dark:border-teal-700 focus:outline-none focus:bg-white"
                    id="grid-city" type="text" placeholder="New Jersey" />
            </div>
            {/* col 4:1 */}
            <div className="w-full px-3">
                <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase dark:text-teal-400"
                    htmlFor="grid-country">
                    Country*
                </label>
                <input {...register('country')}
                    required
                    className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border-2 border-blue-200 rounded appearance-none dark:border-teal-700 focus:outline-none focus:bg-white"
                    id="grid-country" type="text" placeholder="USA" />
            </div>
            {/* col 4:2 */}
            <div className="w-full px-3">
                <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase dark:text-teal-400"
                    htmlFor="grid-zipcode">
                    ZipCode*
                </label>
                <input {...register('pin_code')}
                    required
                    className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border-2 border-blue-200 rounded appearance-none dark:border-teal-700 focus:outline-none focus:bg-white"
                    id="grid-zipcode" type="text" placeholder="4075" />
            </div>
            {/* col 5:1 */}
            <div className="flex flex-col w-full px-3">
                <section className='flex flex-col items-center p-4 bg-gray-200 rounded-lg shadow dark:bg-gray-800'>
                    <p className="text-sm font-bold text-gray-700 uppercase dark:text-teal-400">Final Price</p>                    
                    <p className="text-4xl font-bold text-gray-700 dark:text-gray-100">{generalInfoState?.final_price === 0 ? '...' : `$ ${generalInfoState?.final_price.toFixed(2)}`}</p>
                </section>
            </div>
            {/* col 5:2 */}
            <div className="w-full px-3">
                <button type='submit'
                    className="px-4 py-2 mx-3 my-6 font-bold text-white bg-green-500 border-b-4 border-green-700 rounded hover:bg-green-400 hover:border-green-500">
                    Checkout
                </button>
                <button type='reset'
                    onClick={()=>onBack()}
                    className="px-4 py-2 mx-3 my-6 font-bold text-gray-700 bg-gray-300 border-b-4 border-gray-500 rounded hover:bg-gray-400 hover:text-white hover:border-gray-700">
                    Back
                </button>
            </div>
        </form>
    </section>;
};

export default BillingInfoForm;